import { render, staticRenderFns } from "./SocialNetwork.vue?vue&type=template&id=5ca5562e&scoped=true"
import script from "./SocialNetwork.vue?vue&type=script&lang=ts"
export * from "./SocialNetwork.vue?vue&type=script&lang=ts"
import style0 from "./SocialNetwork.vue?vue&type=style&index=0&id=5ca5562e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca5562e",
  null
  
)

export default component.exports